import { inject, Injectable, WritableSignal } from '@angular/core';
import { WorkflowSection } from '../../models/workflow/workflow-section.model';
import { WorkflowService } from '../../services/workflow.service';

@Injectable({
  providedIn: 'root',
})
export class ProgressFlowService {
  private _workflowService: WorkflowService = inject(WorkflowService);

  showProgressStepper(): WritableSignal<boolean> {
    return this._workflowService.showProgressStepper$;
  }

  getMobileIndex(): WritableSignal<number> {
    return this._workflowService.mobileIndex$;
  }

  getWorkflowSections(): WritableSignal<WorkflowSection[]> {
      return this._workflowService.getWorkflowSections();
    }
}
